export default __webpack_public_path__ + "static/media/LabYellow.188a0289.svg";